import { useMutation } from "@apollo/react-hooks";
import { Modal, Stack } from "@shopify/polaris";
import React, { useCallback, useEffect, useReducer } from "react";
import { START_AMAZON_IDEA } from "../../../graphql/mutations/amazon-idea";
import { arrInvalid, handleError, reducerFn } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";
import { useAmazonIdeaCtx } from "../context";
import StoreSelect from "../../store/components/StoreSelect";
import { getStoreIds } from "../helper";

export default function AmazonIdeaStart({
    open,
    onClose,
    ids,
    onCompleted,
    node,
}) {
    const { setNotify, toggleToast } = useToastContext();
    const { refetch } = useAmazonIdeaCtx();

    const [state, setState] = useReducer(reducerFn, {
        storeIDs: [],
    });

    const [setDelay] = useTimeout();
    const [startAmazonIdea, { loading }] = useMutation(START_AMAZON_IDEA, {
        onCompleted: () => {
            setNotify({
                msg: "Start amazon idea successfully",
                err: false,
            });

            onClose();
            onCompleted && onCompleted();
            setDelay(() => {
                refetch && refetch();
            }, 1500);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        startAmazonIdea({
            variables: {
                ids,
                // storeIDs:
                //     state.storeIDs?.length > 0 ? state.storeIDs : undefined,
            },
        });
    }, [ids, state.storeIDs]);

    const handleStoreChange = useCallback((value) => {
        setState({ storeIDs: value });
    }, []);

    useEffect(() => {
        const storeIds = getStoreIds(node?.stores);
        if (storeIds.length > 0) {
            setState({ storeIDs: storeIds });
        }
    }, [JSON.stringify(node?.stores)]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            sectioned
            title="Start Amazon Idea"
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <Stack vertical>
                <p>Are you sure to start this Idea?</p>

                {/* <StoreSelect
                    value={state.storeIDs}
                    filter={{ platform: "amazon", limit: 200 }}
                    onChange={handleStoreChange}
                    getValueImmediate
                    allowMultiple
                /> */}
            </Stack>
        </Modal>
    );
}
